package com.milta.feature.route.domain.entity

/**
 * MIL-97 — why a create/add call that asked for an optimization did not run RoutaR. [QuotaExceeded]:
 * the account's optimization counter is at 0, the route or batch is still created (R6) and a stop
 * added in progress goes at the end of the route (R7). [RoutarUnavailable]: POST routes/me only,
 * RoutaR failed — the route is created in the entered order instead of a 503.
 */
enum class OptimizationSkippedReason {
    QuotaExceeded,
    RoutarUnavailable,
    ;

    companion object {
        /** Unknown values are ignored rather than failing the whole response. */
        fun fromApi(value: String?): OptimizationSkippedReason? = entries.firstOrNull { it.name == value }
    }
}
